import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class Sanction extends IdCodeLibelle {}
